import { css } from "@emotion/react";
import { PrivacyPolicy } from "./privacyPolicy";
import { Trademark } from "./trademark";

export const AuthenticatorFooter = () => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;
    `}
  >
    <Trademark />
    <PrivacyPolicy />
  </div>
);
